"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasPermissionAtEntity = void 0;
const hasPermissionAtEntity = ({ userPermissions, isAdmin, permissionName, entityId, }) => {
    if (!userPermissions.length)
        return false;
    // Greenline admins have all permissions
    if (isAdmin)
        return true;
    if (entityId === undefined) {
        const foundPermission = userPermissions.find((userPermission) => userPermission.permission.name === permissionName);
        return !!foundPermission;
    }
    else {
        const foundPermission = userPermissions.find((userPermission) => userPermission.permission.name === permissionName &&
            (userPermission.entityId === entityId || userPermission.parentEntityId === entityId));
        return !!foundPermission;
    }
};
exports.hasPermissionAtEntity = hasPermissionAtEntity;
//# sourceMappingURL=UserPermissions.js.map